import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../contexts/AuthContext';
import { ArrowLeftOnRectangleIcon } from '@heroicons/react/24/outline';
import Logo from '../../components/Logo/Logo';
import { consumeRegistrationSuccessNotice } from '../../utils/registrationSuccessNotice';

const PendingAccess: React.FC = () => {
    const { signOut, user, accountStatusNotice, clearAccountStatusNotice } = useAuth();
    const { t } = useTranslation();
    const [showRegistrationSuccess, setShowRegistrationSuccess] = useState(false);

    useEffect(() => {
        if (consumeRegistrationSuccessNotice()) {
            setShowRegistrationSuccess(true);
        }
    }, []);

    return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-neutral-900 px-4 sm:px-6 lg:px-8 fade-in zoom-in-95 slide-in-from-bottom-8 duration-700">
            <div className="max-w-md w-full space-y-8 text-center">
                <div className="flex justify-center">
                    <Logo size="md" className="mb-4" />
                </div>
                {showRegistrationSuccess && (
                    <div
                        role="status"
                        className="rounded-lg border border-green-200 bg-green-50 px-4 py-3 text-left dark:border-green-800 dark:bg-green-950/30"
                    >
                        <p className="text-sm font-medium text-green-700 dark:text-green-400">{t('auth.registrationSuccess')}</p>
                        <button
                            type="button"
                            onClick={() => setShowRegistrationSuccess(false)}
                            className="mt-2 text-xs text-green-800 underline hover:no-underline dark:text-green-300"
                        >
                            {t('pendingAccess.dismissNotice')}
                        </button>
                    </div>
                )}
                {accountStatusNotice === 'pending_revoked' && (
                    <div
                        role="alert"
                        className="rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900 dark:border-amber-800 dark:bg-amber-950/40 dark:text-amber-100"
                    >
                        <p className="font-medium">{t('pendingAccess.revokedBanner')}</p>
                        <button
                            type="button"
                            onClick={clearAccountStatusNotice}
                            className="mt-2 text-xs underline hover:no-underline"
                        >
                            {t('pendingAccess.dismissNotice')}
                        </button>
                    </div>
                )}
                <div>
                    <h2 className="mt-6 text-3xl font-extrabold text-gray-900 dark:text-white">
                        {t('pendingAccess.title')}
                    </h2>
                    <p className="mt-2 text-sm text-gray-600 dark:text-gray-400">
                        Hello {user?.email}
                    </p>
                    <p className="mt-4 text-lg text-gray-500 dark:text-gray-300">
                        {t('pendingAccess.waitingMessage')}
                        <br />
                        {t('pendingAccess.approvalMessage')}
                    </p>
                </div>

                <div className="mt-8">

                    <button
                        onClick={signOut}
                        className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 dark:focus:ring-offset-neutral-900"
                    >
                        <span className="absolute left-0 inset-y-0 flex items-center pl-3">
                            <ArrowLeftOnRectangleIcon className="h-5 w-5 text-indigo-500 group-hover:text-indigo-400" aria-hidden="true" />
                        </span>
                        {t('pendingAccess.signOut')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PendingAccess;
